/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_tp.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions TP */
HafasWebapp.prototype.subscriptions.tp = function (_me) {
  /* Start Ziel tauschen */
  Hafas.ps.sub('/tp/switchFromTo', Hafas.bind(function () {
    _me.Controller.TP.instance.switchLocations();
    var btnClass = Hafas("#HFS_TPCoreForm .lyr_changeDirBtn"), clsName = 'lyr_oppdirRotate';
    if (btnClass.classList.contains(clsName)) {
      btnClass.removeClassName(clsName);
    } else {
      btnClass.addClassName(clsName);
    }

    var _inst = _me.Controller.TP.instance.data.query;
    if (!_inst.depLocL[0] || !_inst.arrLocL[0]) return;
    Hafas.ps.pub("/tp/events/trigger/unified");
    Hafas.ps.pub('/tracking/event/journey-planner-switch-directions', [{
      typ: 'event',
      key: 'journey-planner-switch-directions'
    }]);
    Hafas.ps.pub('/tracking/event/tripplanner-switchdirections-pressed', [{
      typ: 'event',
      key: 'tripplanner-switchdirections-pressed'
    }]);

    Hafas.bind(_me.Controller.TP.onFormularChange, _me)();
  }, _me));

  Hafas.ps.sub('/map/select', Hafas.bind(function (type, location) {
    // Tracking
    if (type === 'dep') Hafas.ps.pub('/tracking/event/mapflyout-start-pressed', [{
      typ: 'event',
      key: 'mapflyout-start-pressed'
    }]);
    if (type === 'arr') Hafas.ps.pub('/tracking/event/mapflyout-destination-pressed', [{
      typ: 'event',
      key: 'mapflyout-destination-pressed'
    }]);
    _me.Controller.TP.instance.setLocation(type, location);
  }, _me));

  Hafas.ps.sub('/map/select', Hafas.bind(function (type, location) {
    var $detailsHeader = Hafas('#TP_ResultDetail .lyr_atomActionbarWrapper', false);
    if ($detailsHeader) {
      Hafas.ps.pub('/app/events/closeResults', [{
        appcontext: 'TP',
        resultSet: 'detail',
        ev: {
          preventDefault: function () {
          }
        }
      }]);
    }

    if (_me.appContext === 'TP') {
      if (Hafas.Config.TP.unifiedPlanner.show == false) {
        Hafas.ps.pub('/app/events/closeResults', [{
          appcontext: 'TP',
          resultSet: 'overview',
          ev: {
            preventDefault: function () {
            }
          }
        }]);
      }
    }

    if (Hafas.Config.TP.unifiedPlanner.show == false || this.layoutClass == 'small') {
      Hafas.ps.pub('/GUI/map/hide', []);
    }


    var locationDataModel = { name: location.name, lid: location.lid };
    _me.Controller.TP.instance.setLocation(type, locationDataModel);

    // Koordinaten werden nicht zu den Favoriten hinzugefügt
    if (Hafas.Config.Switches.useFavorites && Hafas.Config.Favorites.addLocationOnSuggest && location.type != 'C') {
      var depLocProducts = location.icnClass;
      var depLocHistory = { name: location.name, lid: location.lid, prod: depLocProducts };
      _me.Controller.Favorites.instance.addLocation(depLocHistory, 'History');
    }

    if (Hafas.Config.TP.unifiedPlanner.show == false) {
      Hafas.bind(_me.Controller.TP.renderIndex, _me)();
    } else {
      Hafas.ps.pub('/tp/postForm', [{ form: Hafas('#HFS_FormTripSearch') }]);
      Hafas.ps.pub('/app/events/resize', []);
    }

  }, _me));

  Hafas.ps.sub('/tp/selectLocation', Hafas.bind(_me.Controller.TP.setLocation, _me));


  // Setzte Datum und Zeit
  Hafas.ps.sub('/tp/setDate', Hafas.bind(_me.Controller.TP.setDate, _me));
  Hafas.ps.sub('/tp/setTime', Hafas.bind(_me.Controller.TP.setTime, _me));

  //backToTop
  Hafas.ps.sub('/tp/ScrollBack', Hafas.bind(_me.Controller.TP.backToTop, _me));


  Hafas.ps.sub('/tp/postForm', Hafas.bind(_me.Controller.TP.postForm, _me));
  Hafas.ps.sub('/tp/toggleDetails', Hafas.bind(_me.Controller.TP.toggleDetails, _me));
  Hafas.ps.sub('/tp/showDetails', Hafas.bind(_me.Controller.TP.showDetails, _me));
  Hafas.ps.sub('/tp/hideDetails', Hafas.bind(_me.Controller.TP.hideDetails, _me));

  Hafas.ps.sub('/tp/toggleSelectedTicketDetails', Hafas.bind(_me.Controller.TP.toggleTicketBannerDetails, _me));

  Hafas.ps.sub('tp/onPerdiodChange', Hafas.bind(_me.Controller.TP.actions.onChangePeriod, _me));
  Hafas.ps.sub('tp/onReturnChange', Hafas.bind(_me.Controller.TP.actions.onChangeReturn, _me));

  Hafas.ps.sub('tp/onAdultCount', Hafas.bind(_me.Controller.TP.actions.onAdultCount, _me));
  Hafas.ps.sub('tp/onChildCount', Hafas.bind(_me.Controller.TP.actions.onChildCount, _me));
  Hafas.ps.sub('tp/onStudentCount', Hafas.bind(_me.Controller.TP.actions.onStudentCount, _me));

  Hafas.ps.sub('/tp/changeDay', Hafas.bind(_me.Controller.TP.actions.onChooseDay, _me));

  Hafas.ps.sub('/tp/selectTicket', Hafas.bind(_me.Controller.TP.actions.selectTicket, _me));
  Hafas.ps.sub('/tp/focusTicket', Hafas.bind(_me.Controller.TP.actions.focusTicket, _me));

  Hafas.ps.sub('/tp/bookTicket', Hafas.bind(_me.Controller.TP.actions.bookTicket, _me));
  Hafas.ps.sub('/tp/jumoToTicketShop', Hafas.bind(_me.Controller.TP.actions.jumpToTicketShop, _me));
  Hafas.ps.sub('/tp/chooseOutward', Hafas.bind(_me.Controller.TP.actions.chooseOutward, _me));
  Hafas.ps.sub('/tp/chooseReturn', Hafas.bind(_me.Controller.TP.actions.chooseReturn, _me));
  Hafas.ps.sub('/tp/chooseSocialOutward', Hafas.bind(_me.Controller.TP.actions.chooseSocialOutward, _me));
  Hafas.ps.sub('/tp/chooseSocialReturn', Hafas.bind(_me.Controller.TP.actions.chooseSocialReturn, _me));

  Hafas.ps.sub('/tp/showWheelchairOptions', Hafas.bind(_me.Controller.TP.actions.showWheelchairOptions, _me));
  Hafas.ps.sub('/tp/showSeatOptions', Hafas.bind(_me.Controller.TP.actions.showSeatOnlyOptions, _me));

  Hafas.ps.sub('/tp/showPassengerOptions', Hafas.bind(_me.Controller.TP.actions.showPassengerOptions, _me));
  Hafas.ps.sub('/tp/savePassengerOptions', Hafas.bind(_me.Controller.TP.actions.savePassengerOptions, _me));
  Hafas.ps.sub('/tp/changePassangerCount', Hafas.bind(_me.Controller.TP.actions.changePassangerCount, _me));
  Hafas.ps.sub('/tp/showPassengerPopUpOverlay', Hafas.bind(_me.Controller.TP.actions.passengerInfoPopUpOverlay, _me));

  Hafas.ps.sub('/tp/saveWheelcharOptions', Hafas.bind(_me.Controller.TP.actions.saveWheelcharOptions, _me));
  Hafas.ps.sub('/tp/changeWheelchairCount', Hafas.bind(_me.Controller.TP.actions.changeWheelchairCount, _me));

  Hafas.ps.sub('/tp/saveSeatOnlyOptions', Hafas.bind(_me.Controller.TP.actions.saveSeatOnlyOptions, _me));

  Hafas.ps.sub('/tp/setBikeFilter', Hafas.bind(_me.Controller.TP.actions.setBikeFilter, _me));

  Hafas.ps.sub('/tp/jumpToBooking', Hafas.bind(_me.Controller.TP.actions.jumpToBooking, _me));

  // Funktion zum Ändern jeglicher Anfrageoptionen von extern
  Hafas.ps.sub('/tp/setExternJnyOptions', Hafas.bind(_me.Controller.TP.setExternJnyOptions, _me));

  // Kundenanpassung Map
  Hafas.ps.sub('/tp/showRouteMap', Hafas.bind(_me.Controller.TP.showRouteMap, _me));
  Hafas.ps.sub('/tp/hideRouteMap', Hafas.bind(_me.Controller.TP.hideRouteMap, _me));
  Hafas.ps.sub('/map/controlClicked/geoposition', Hafas.bind(function(control,map){
    _me.Controller.TP.showGeoPosition(map);
  },_me));
  // Kundenanpassung Map Ende

  // Vorbelegung Start/Ziel
  Hafas.ps.sub('/tp/setLocationValue/webapp', Hafas.bind(function (type, location) {

    var locationName = '';
    if (location != null) {
      locationName = location.name;
    }

    var input = null;

    if (_me.appContext === 'TP') {
      if (type == "dep") {
        input = Hafas('#From', false);
      } else if (type == "arr") {
        input = Hafas('#To', false);
      } else if (type == "via") {
        input = Hafas('#Via', false);
      }
    }


    // only set value if it's different to the current one
    if (input != null && input.value !== locationName) {
      input.value = locationName;

      if (locationName) {
        // find matching label for screenreader announcement
        var label = (Hafas('label[for="' + input.id + '"]') || {});
        Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
          element: (label.textContent || Hafas.Modules.i18n.get('common.label.t_N_Unknown')),
          text: locationName
        }));
      }
    }

    if (_me.appContext != 'TP') {
      Hafas.ps.pub('/app/switchContext', [{ context: 'TP', method: 'index' }]);
    }
  }, _me));

  // Aktualisierung GUI bei Setzen der Location
  Hafas.ps.sub('/tp/setLocation/webapp', Hafas.bind(function (type, location) {
    Hafas.ps.pub('/tp/setLocationValue/webapp', [type, location]);
  }, _me));


  // TP Modul wird verlassen
  Hafas.ps.sub('/GUI/leaveContext/TP', Hafas.bind(_me.Controller.TP.cleanup, _me));

  // History Back
  Hafas.ps.sub('/GUI/closeView/TP', Hafas.bind(_me.Controller.TP.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/TP', Hafas.bind(_me.Controller.TP.restoreView, _me));

  Hafas.ps.sub('/tp/searchReconstruction', Hafas.bind(_me.Controller.TP.searchReconstruction, _me));
  Hafas.ps.sub('/tp/reconstructionComplete', Hafas.bind(_me.Controller.TP.showReconstructedConnection, _me));

  Hafas.ps.sub('/tp/jumpToSQ', Hafas.bind(function (data) {
    var location = _me.Controller.TP.instance.getLocation(data);
    Hafas.ps.pub('/app/switchContext', [{ context: "SQ" }]);
    _me.Controller.SQ.instance.setLocation(location);
    _me.Controller.SQ.instance.setBoardType(data);
    _me.Controller.SQ.instance.search(Hafas.bind(_me.Controller.SQ.showResult, _me));

  }, this));

  Hafas.ps.sub('/tp/showShareLink', Hafas.bind(_me.Controller.TP.showShareLink, _me));
  Hafas.ps.sub('/tp/copySharLinkToClipboard', Hafas.bind(_me.Controller.TP.onCopyShareLinkToClipboard, _me));

  // Debug
  Hafas.ps.sub('/tp/printSearchLink', Hafas.bind(_me.Controller.TP.printSearchLink, _me));
  Hafas.ps.sub('/tp/printReconstructionLink', Hafas.bind(_me.Controller.TP.printReconstructionLink, _me));
  Hafas.ps.sub('/tp/printSelectedConnection', Hafas.bind(_me.Controller.TP.printSelectedConnection, _me));

  Hafas.ps.sub('/tp/toggleInterStops', Hafas.bind(_me.Controller.TP.toggleInterStops, _me));
  Hafas.ps.sub('/tp/editTicketOptoins', Hafas.bind(_me.Controller.TP.backToTop, _me));


};
